var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-time-label',{attrs:{"value":_vm.now,"format":_vm.format}})}
var staticRenderFns = []

export { render, staticRenderFns }